import { paragon } from "@useparagon/connect";

// The Paragon SDK is a window-level singleton. Concurrent calls to
// paragon.authenticate() from multiple hook instances (or React StrictMode's
// double-invocation in dev) can race. Dedupe by JWT.
let inflight: { jwt: string; promise: Promise<void> } | null = null;

export async function ensureParagonAuthenticated(
  projectId: string,
  jwt: string,
): Promise<void> {
  if (inflight?.jwt === jwt) {
    return inflight.promise;
  }
  const promise = paragon.authenticate(projectId, jwt).then(
    () => undefined,
    (err) => {
      if (inflight?.jwt === jwt) {
        inflight = null;
      }
      throw err;
    },
  );
  inflight = { jwt, promise };
  return promise;
}
